import Vue from 'vue'
import Banner from './components/Banner';
import Lineup from './components/Lineup';
import Accommodation from './components/Accommodation';
import Traders from './components/Traders';
import SpotifyLineup from './components/SpotifyLineup';
import Ticker from './components/Ticker';
import 'promise-polyfill/src/polyfill';

Vue.config.productionTip = false;

import VueSocialSharing from 'vue-social-sharing'
Vue.use(VueSocialSharing);

let fitVids = require('./components/FitVids.jquery.js');
let concertinas = require('./components/Concertinas.jquery.js');
let emailOctopus = require('./components/EmailOctopus.jquery.js');


// Fix for Vue removing jQuery event handlers
jQuery.holdReady(true);

document.addEventListener('DOMContentLoaded', function (event) {
    document.getElementsByTagName('body')[0].classList.remove('no-js');

    new Vue({
        el: '#app',
        components: {
            Accommodation,
            Banner,
            Lineup,
            SpotifyLineup,
            Ticker,
            Traders,
        },
        mounted() {
            let self = this;

            // Fix for Vue removing jQuery event handlers
            jQuery.holdReady(false);


            let font1 = new FontFaceObserver('interstate-condensed', {
                weight: 500,
            });
            let font2 = new FontFaceObserver('interstate-condensed', {
                weight: 700,
            });
            let font3 = new FontFaceObserver('interstate-condensed', {
                weight: 800,
            });
            let timeout = 10000;

            Promise.all([
                font1.load(null, timeout),
                font2.load(null, timeout),
                font3.load(null, timeout),
            ]).then(function () {
                self.setFirstOnLine();
            }, function() {
                // Failed to load fonts. Just do it.
                self.setFirstOnLine();
            });


            self.setFirstOnLine();

            window.onresize = function () {
                self.setFirstOnLine();
            };
        },


        methods: {
            setFirstOnLine: function () {
                jQuery('.js-set-first-on-line, .foot-nav .menu').each(function () {
                    let offset = null;
                    jQuery(this).children(':visible').each(function () {
                        let element_offset = parseInt(jQuery(this).offset().top);
                        //console.log(element_offset.toString() + ': ' + jQuery(this).text().trim());

                        if (offset !== element_offset) {
                            jQuery(this).addClass('is-first_on_line');
                        } else {
                            jQuery(this).removeClass('is-first_on_line');
                        }

                        offset = element_offset;
                    });
                });
            },
        }
    });


    fitVids();
    concertinas();
    emailOctopus();
});

